import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
  parishId: localStorage.getItem('parishId') ? JSON.parse(localStorage.getItem('parishId')) : null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      state.parishId = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
      localStorage.setItem('parishId', JSON.stringify(action.payload));
    },
    logout: (state, action) => {
      state.userInfo = null;
      state.parishId = null;
      localStorage.removeItem('userInfo');
      localStorage.removeItem('parishId');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
